"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Anchor = exports.DiscardButton = exports.ButtonWrapper = exports.MultipleItemsContainer = exports.Separator = exports.CloseButton = exports.DialogHeader = exports.Discount = exports.MSRP = exports.Amount = exports.Quantity = exports.Name = exports.Brand = exports.PriceRow = exports.Row = exports.Detail = exports.ProductContainer = exports.Checkmark = exports.Checkbox = exports.ImageCheckContainer = exports.Image = exports.Footer = exports.Paragraph = exports.Title = exports.Container = void 0;
const button_1 = __importDefault(require("@kawaui/button"));
const discount_1 = __importDefault(require("@kawaui/discount"));
const Check_1 = __importDefault(require("@kawaui/icons/build/icons/informative/Check"));
const Cross_1 = __importDefault(require("@kawaui/icons/build/icons/navigation/Cross"));
const placeholder_1 = require("@kawaui/placeholder");
const price_1 = __importDefault(require("@kawaui/price"));
const styled_components_1 = __importStar(require("styled-components"));
const WIDTH = '460px';
const BaseContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
`;
exports.Container = (0, styled_components_1.default)(BaseContainer) `
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: 100%;
  max-height: inherit;
  padding-top: ${({ theme }) => theme.space.s400};

  color: ${({ theme }) => theme.colors.gray.s700};

  font-family: ${({ theme }) => theme.fontFamily.text};
  font-weight: 500;

  ${({ isHardChoice }) => !isHardChoice &&
    (0, styled_components_1.css) `
      padding-top: ${({ theme }) => theme.space.s200};
    `}
`;
exports.Title = styled_components_1.default.div `
  padding: 0 ${({ theme }) => theme.space.s200};

  color: ${({ theme }) => theme.colors.gray.s800};

  font-family: ${({ theme }) => theme.fontFamily.title};
  font-size: 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    padding: 0 ${({ theme }) => theme.space.s400};
  }
`;
exports.Paragraph = styled_components_1.default.div `
  max-width: ${WIDTH};
  padding: 0 ${({ theme }) => theme.space.s200};
  margin-top: ${({ theme }) => theme.space.s100};
  margin-bottom: ${({ theme }) => theme.space.s400};

  line-height: 1.38;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    padding: 0 ${({ theme }) => theme.space.s400};
  }
`;
exports.Footer = styled_components_1.default.div `
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  padding: 0 ${({ theme }) => theme.space.s200};
  margin: ${({ theme }) => theme.space.s200} 0;

  ${({ isMobile }) => !!isMobile &&
    (0, styled_components_1.css) `
      flex-direction: column-reverse;
    `}

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    flex-direction: row;
    padding: 0 ${({ theme }) => theme.space.s400};
  }
`;
exports.Image = (0, styled_components_1.default)(placeholder_1.Img) `
  ${({ isChecked }) => !isChecked &&
    (0, styled_components_1.css) `
      filter: grayscale(0.2);
      opacity: 0.6;
    `};
`;
exports.ImageCheckContainer = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex: 1;
  box-sizing: border-box;
  min-width: 50px;
  max-width: 150px;
  min-height: 50px;
  max-height: 150px;
  border: 1px solid transparent;

  cursor: pointer;

  ${({ isChecked }) => isChecked &&
    (0, styled_components_1.css) `
      border-color: ${({ theme }) => theme.colors.main.base};
    `}
`;
exports.Checkbox = styled_components_1.default.div `
  position: absolute;
  bottom: 10px;
  left: 10px;

  width: 20px;
  height: 20px;
  padding: ${({ theme }) => theme.space.s025};
  border: 1px solid ${({ isChecked, theme: { colors } }) => (isChecked ? colors.main.base : colors.gray.s300)};

  background-color: ${({ isChecked, theme: { colors } }) => (isChecked ? colors.main.base : colors.white.s100)};

  border-radius: 100%;
`;
exports.Checkmark = (0, styled_components_1.default)(Check_1.default).attrs(() => ({ height: '100%', width: '100%' })) `
  path {
    fill: white;
  }
`;
exports.ProductContainer = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.space.s200};

  &:last-child {
    margin-bottom: 0;
  }
`;
exports.Detail = styled_components_1.default.div `
  flex: 1;
  padding: 0 ${({ theme }) => theme.space.s100};

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    padding: 0 ${({ theme }) => theme.space.s200};
  }
`;
exports.Row = styled_components_1.default.div `
  display: flex;
  margin-bottom: ${({ theme }) => theme.space.s050};

  line-height: 1.25;
`;
exports.PriceRow = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  font-size: 1.25rem;
`;
exports.Brand = styled_components_1.default.div `
  color: ${({ theme }) => theme.colors.gray.s800};

  font-family: ${({ theme }) => theme.fontFamily.title};
  font-weight: 500;
`;
exports.Name = styled_components_1.default.div `
  color: ${({ theme }) => theme.colors.gray.s700};
`;
exports.Quantity = styled_components_1.default.div `
  color: ${({ theme }) => theme.colors.gray.s700};
`;
exports.Amount = (0, styled_components_1.default)(price_1.default) `
  color: ${({ theme }) => theme.colors.main.base};
  font-weight: 600;
`;
exports.MSRP = (0, styled_components_1.default)(price_1.default) `
  margin-right: ${({ theme }) => theme.space.s100};

  font-weight: 500;
`;
exports.Discount = (0, styled_components_1.default)(discount_1.default) `
  margin-left: ${({ theme }) => theme.space.s100};

  ${({ isAbsolute }) => isAbsolute &&
    (0, styled_components_1.css) `
      position: absolute;
      left: 0;
      bottom: 12px;
    `};
`;
exports.DialogHeader = styled_components_1.default.div `
  padding: 0 ${({ theme }) => theme.space.s200};
  margin-bottom: 1.5rem;
`;
exports.CloseButton = (0, styled_components_1.default)(Cross_1.default) `
  width: 24px;
  height: 24px;

  cursor: pointer;

  path {
    fill: ${({ theme }) => theme.colors.gray.s700};
  }
`;
exports.Separator = styled_components_1.default.div `
  margin-right: ${({ theme }) => theme.space.s200};
  margin-bottom: ${({ theme }) => theme.space.s200};
`;
exports.MultipleItemsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  max-width: ${WIDTH};
  padding: 0 ${({ theme }) => theme.space.s200};

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    padding: 0 ${({ theme }) => theme.space.s400};
  }
`;
exports.ButtonWrapper = styled_components_1.default.div `
  flex: 1;
`;
exports.DiscardButton = (0, styled_components_1.default)(button_1.default) `
  @media (max-width: ${({ theme }) => theme.breakpoint.tablet}) {
    width: 100%;
  }
`;
exports.Anchor = styled_components_1.default.a.attrs(() => ({
    onClick: (e) => {
        e.preventDefault();
    },
})) ``;
